import { throw_ } from './helpers';
import * as helpers from './helpers';

export type enddate_compute = { duration: string } | { nextDate: string }
const compute_enddate_one = (startdate: Date, enddate_compute: enddate_compute) => {
    if ("nextDate" in enddate_compute) {
        return helpers.nextDate(enddate_compute.nextDate, startdate)
    } else {
        const [ , number_, what ] = enddate_compute.duration.match(/^(\d+)([JMA])$/) || throw_("compute_enddate invalid duration " + enddate_compute.duration)
        const number = parseInt(number_)
    
        switch (what.toUpperCase()) {
            case "J":
                return helpers.addDays(startdate, number)
            case "A":
                return helpers.addYears(startdate, number)
        }
        throw "internal error"
    }
}

export const compute_enddate = (startdate: Date, enddate_computes: enddate_compute[]) => {
    let date = startdate
    for (const one of enddate_computes) {
        date = compute_enddate_one(date, one)
    }
    return date
}
